<template>
  <div class="errore">
    <div class="errore-box shadow">
      <div class="errore-title">
        {{ labels.ERR ? labels.ERR : "ERRORE" }}
        <button class="back-btn" @click="goBack">
          <fa v-if="_backicon.enabled" :icon="_backicon.icon" />
          {{ _backtext }}
        </button>
      </div>
      <div>
        <div v-for="errore in $store.err" :key="errore" class="errore-text"><fa class="fa circle" :icon="['fas', 'circle']" />{{ errortext(errore) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import formService from "../services/form";

const DEFAULT_BACKICON = ["fas", "long-arrow-alt-left"];

export default {
  data() {
    return {
      labels: { privacy: {} },
      def: {
        ERR_RPC: "Dati configurazione mancanti",
        ERR_IDHOTEL: "Dati configurazione mancanti",
        ERR_GENERIC: "Errore sconosciuto",
        ERR_NEXI: "Non è stato possibile verificare l'esito del pagamento: contatta la struttura prima di riprovare",
        ERR_PRENO_PAGATA: "Il pagamento è stato eseguito ma non è stato possibile registrare la prenotazione: contatta la struttura",
        ERR_PRENO: "Prenotazione non trovata",
        ERR_HOTEL: "Hotel non trovato",
        ERR_EXPIRED: "Riepilogo prenotazione scaduto",
        ERR_PREV_SCAD: "Preventivo scaduto"
      }
    };
  },
  computed: {
    _backicon() {
      const isBackicon = typeof this.$store?.form?.icon !== "undefined";
      if (isBackicon) {
        let icon = DEFAULT_BACKICON;
        if (Array.isArray(this.$store.form.icon)) {
          icon = this.$store.form.icon;
        }
        return {
          enabled: !!this.$store.form.icon,
          icon
        };
      }
      return {
        enabled: true,
        icon: DEFAULT_BACKICON
      };
    },
    _backtext() {
      return this.labels[this.$store?.backbtn] ?? this.labels[this?.form?.backbtn] ?? this.labels.IndietroHome;
    }
  },
  mounted() {
    formService.init(this);
    if (!this.$store.err?.length) {
      this.$store.err = ["ERR_GENERIC"];
    }
  },
  methods: {
    errortext(err) {
      return this.labels[err] ?? this.def[err] ?? err;
    },
    goBack() {
      let path = "";
      let resetform = false;
      if (this.$store.backpath) {
        path = this.$store.backpath;
        resetform = this.$store.resetform ?? false;
      } else {
        path = this.$store._home_path;
        resetform = true;
      }

      if (resetform) {
        this.$store.form = null;
      }
      this.$router.replace(path);
    }
  }
};
</script>

<style lang="scss">
@import "../css/variables.scss";

button {
  all: unset;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  &[right] {
    justify-content: flex-end;
  }
  &.back-btn {
    background-color: transparent;
    &:hover {
      background-color: #fff3;
    }
  }
}

.errore {
  top: 7em;
  position: absolute;
  margin: 20px;
  padding: 0 5.6%;
  left: 0;
  right: 0;
  text-align: left;
  .errore-box {
    display: inline-block;
    background-color: white;
    min-width: 500px;
    max-width: 90%;
    min-height: 200px;
    .errore-title {
      padding: 8px 20px;
      border-bottom: 2px solid darken($negative, 10%);
      color: white;
      font-weight: bold;
      font-size: 1.2em;
      background-color: $negative;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .errore-text {
      padding: 10px 20px;
      .circle {
        font-size: 0.7em;
        padding-bottom: 3px;
        margin-right: 7px;
      }
    }
  }
}
</style>
